import { apiService } from './apiService';

export const reportService = {
  async getReturnLoadPotential(params?: { startDate?: string; endDate?: string }) {
    const query = new URLSearchParams();
    if (params?.startDate) query.set('startDate', params.startDate);
    if (params?.endDate) query.set('endDate', params.endDate);
    return await apiService.get(`/reports/return-load-potential${query.toString() ? `?${query.toString()}` : ''}`);
  },
};
